import styled from 'styled-components';
import { PiWarningCircleFill } from 'react-icons/pi';

import theme from '@styles/theme';

import { FlexBox } from '@components/styled/StyledComponents';
import StyledModal from '@components/styled/StyledModal';
import StyledButton from '@components/styled/StyledButton';
import { Dispatch, SetStateAction } from 'react';

type SecedeConfirmModalProps = {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    handleSecede: () => void;
};

const SecedeConfirmModal = ({
    isOpen,
    setIsOpen,
    handleSecede
}: SecedeConfirmModalProps) => {
    return (
        <StyledModal isOpen={isOpen} width="630px" LOCK_BG>
            <FlexBox $gap={12} $margin="0 0 32px">
                <PiWarningCircleFill
                    size={32}
                    color={theme.colors.activeOrange}
                />
                <Title>서비스 탈퇴시 아래와 같은 절차가 진행됩니다.</Title>
            </FlexBox>
            <Text>
                이미지 및 영상 등의 정보와 함께 회원정보가 즉시 삭제됩니다.
                <br />
                기기 철수 절차를 위한 해피콜이 진행됩니다.
            </Text>
            <FlexBox $justifyContent="flex-end" $gap={20} $margin="40px 0 0">
                <StyledButton
                    title="탈퇴하기"
                    width={142}
                    fontColor={theme.colors.lightGrayFontColor}
                    bgColor={theme.colors.whiteColor}
                    border={`${theme.colors.ultraLightGrayBorder} 1px solid`}
                    onClick={handleSecede}
                />
                <StyledButton
                    title="취소하기"
                    width={142}
                    bgColor={theme.colors.activeOrange}
                    onClick={() => setIsOpen(false)}
                />
            </FlexBox>
        </StyledModal>
    );
};

export default SecedeConfirmModal;
const Title = styled.div`
    font-size: 20px;
    font-family: PretendardSemiBold, sans-serif;
    color: ${theme.colors.activeOrange};
`;
const Text = styled.div`
    overflow-y: auto;
    white-space: pre-wrap;
`;
